const ITEMS = [
  "Strength",
  "Speed",
  "Explosive Power",
  "SF Giants Pro Experience",
  "Performance Tracking",
  "Arm Care",
  "Nutrition",
  "Athlete Development",
];

export default function Marquee() {
  const row = (key) => (
    <div key={key} className="flex shrink-0 items-center">
      {ITEMS.map((item, i) => (
        <span key={`${key}-${i}`} className="flex items-center">
          <span
            className={`font-display uppercase text-2xl sm:text-3xl tracking-wide px-6 ${
              i % 2 === 0 ? "text-white" : "text-zinc-600"
            }`}
          >
            {item}
          </span>
          <span className="w-2 h-2 bg-[#CCFF00] rotate-45 shrink-0" />
        </span>
      ))}
    </div>
  );

  return (
    <div
      className="relative border-y border-zinc-800/80 bg-[#0B0B0C] py-5 overflow-hidden"
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
}
